import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import StateEChallanList from "../state-e-challan-list";

const StateEChallanTables = ({ topOffenses = {}, threshold }) => {

    return (
        <div styleName={"styles.container"}>
            <div styleName={"styles.boxWrapper"}>
                <StateEChallanList data={topOffenses} threshold={threshold} />
            </div>
        </div>
    );
};

StateEChallanTables.propTypes = {
    topOffenses: PropTypes.object,
    threshold: PropTypes.number
};

export default StateEChallanTables;
